<template>
  <div class="fixed top-0 left-0 right-0 z-40">
    <div
      class="fixed top-0 right-0 h-screen overflow-hidden border-l border-neutral-100 bg-white shadow-sm"
      :style="{ width: `${widthPercentage ?? 80}%` }"
    >
      <div class="grid h-screen grid-rows-[2.125rem_1fr] gap-2 overflow-hidden px-8 py-7">
        <header class="flex items-center justify-between">
          <slot name="header">
            <div class="flex-1">
              <h1 class="text-xl font-bold text-neutral-700">
                {{ title }}
                <span
                  v-if="editable && title"
                  v-permission="{ ids: editPermissionIds, hide: false }"
                  class="ml-0.5 cursor-pointer text-neutral-400 hover:text-neutral-600"
                  @click="emit('edit')"
                >
                  <font-awesome-icon :icon="['far', 'pen-to-square']" size="1x" />
                </span>
              </h1>
              <p v-if="subtitle" class="text-sm text-neutral-500">
                {{ subtitle }}
              </p>
            </div>
          </slot>

          <div class="flex-initial">
            <slot name="actions"></slot>
          </div>
          <InfuseIconButton v-if="parentTo" :icon="['fas', 'xmark']" size="lg" :to="parentTo" />
        </header>

        <main class="h-full overflow-hidden">
          <slot></slot>
        </main>
      </div>
    </div>
    <div
      class="fixed top-0 left-0 h-screen overflow-hidden bg-transparent"
      @click="onBack"
      :style="{ width: `${100 - (widthPercentage ?? 80)}%` }"
    />
  </div>
</template>

<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { InfuseIconButton } from '@infuse/ui/components';
import { RouteLocationRaw, useRouter } from 'vue-router';
import { vPermission } from '@infuse/iam/permission/directives';
import { computed } from 'vue';

const router = useRouter();

const props = defineProps<{
  title?: string;
  subtitle?: string;
  parentTo?: RouteLocationRaw;
  widthPercentage?: number;
  editable?: boolean;
  editPermissionId?: string;
}>();

const editPermissionIds = computed(() => {
  return props.editPermissionId ? [props.editPermissionId] : [];
});

const emit = defineEmits<{
  edit(): void;
}>();

function onBack() {
  if (props.parentTo) {
    router.push(props.parentTo);
  }
}
</script>
